import { INVOICE_TOUR_TARGET_CATALOG, type InvoiceTourTargetKey } from './catalog'
import type { TourRouteMatch, TourTargetCatalogEntry } from './types'

export const isKnownTourTargetKey = (key: string): key is InvoiceTourTargetKey =>
  key in INVOICE_TOUR_TARGET_CATALOG

export const resolveTourRoute = (
  route: string,
  launchContext?: Record<string, string>,
): string => {
  if (!launchContext) {
    return route
  }

  return Object.entries(launchContext).reduce((resolvedRoute, [paramKey, paramValue]) => {
    const token = `:${paramKey}`
    return resolvedRoute.split(token).join(paramValue)
  }, route)
}

const getPrefixRoute = (route: string): string => {
  if (route.includes('/app/themes/edit/')) {
    return '/app/themes/edit/'
  }

  if (route.includes('/app/themes/code/')) {
    return '/app/themes/code/'
  }

  return route
}

export const resolveTourTarget = (
  key: string,
  launchContext?: Record<string, string>,
): {
  element: string
  tooltipElement?: string
  navigationRoute: string
  route: string
  routeMatch: TourRouteMatch
  matchPaths?: string[]
  waitTimeoutMs?: number
  interactionMode?: 'interactive'
  advanceOnPath?: string
  advanceOnPathMatch?: 'exact' | 'prefix'
  advanceOnClick?: string
} | null => {
  if (!isKnownTourTargetKey(key)) {
    return null
  }

  const entry: TourTargetCatalogEntry = INVOICE_TOUR_TARGET_CATALOG[key]
  const navigationRoute = resolveTourRoute(entry.route, launchContext)
  const routeMatch = entry.routeMatch ?? 'exact'

  return {
    element: entry.selector,
    tooltipElement: entry.tooltipSelector,
    route: routeMatch === 'prefix' ? getPrefixRoute(navigationRoute) : navigationRoute,
    routeMatch,
    matchPaths: entry.matchPaths,
    navigationRoute,
    waitTimeoutMs: entry.waitTimeoutMs,
    interactionMode: entry.interactionMode,
    advanceOnPath: entry.advanceOnPath,
    advanceOnPathMatch: entry.advanceOnPathMatch,
    advanceOnClick: entry.advanceOnClick,
  }
}
